<template lang="html">
  <div>
    <template v-if="!sourceAccount">
      <input class="form-control"
             type="text" :disabled="disabled"
             :value="value" @input="onInput"/>
    </template>
    <div class="input-group" v-if="sourceAccount" :class="inputGroupClass">
      <input class="form-control" type="text" :disabled="disabled" :value="value" @input="onInput"/>
      <div class="input-addon" @click="onAvailBalanceClick">
        <div>
          <div class="total-label"><small>{{ totalLabel }}</small><br/><b>{{
              MoneyFormatFilter(sourceAccount.availBalance, sourceAccount.currency) }}</b> {{ sourceAccount.currency }}</div>
        </div>
      </div>
    </div>
  </div>

</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Account } from '@/models/finance/account';
import { MoneyFormatFilter } from '@/models/filters/money';

@Component({
  name: 'input-amount',
  filters: {
    money: MoneyFormatFilter,
  },
  methods: {
    MoneyFormatFilter,
  },
})
export default class InputAmount extends Vue {
  @Prop({})
  sourceAccount!: Account | null

  @Prop({ default: 'Всего' })
  totalLabel!: string

  @Prop({ default: '' })
  value!: string

  @Prop({ default: false })
  disabled!: boolean

  @Prop({ default: (value: string) => value })
  filter?: (value: string) => string

  get inputGroupClass() {
    return {
      'disabled-input-group': this.disabled,
    };
  }

  onMounted() {
    this.onValueChange(this.value, '')
  }

  @Watch('value')
  onValueChange(value: string, oldValue: string) {
    const filteredValue = this.filter ? this.filter(value) : value;
    if (filteredValue !== value) {
      this.$emit('input', filteredValue);
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    }
  }

  @Watch('sourceAccount')
  onAccountChange(value: string, oldValue: string) {
    const filteredValue = this.filter ? this.filter(this.value) : this.value;
    if (filteredValue !== this.value) {
      this.$emit('input', filteredValue);
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    }
  }

  onInput($event: any) {
    const val = $event.target.value;
    this.$emit('input', this.filter ? this.filter(val) : val);
    this.$nextTick(() => {
      this.$forceUpdate();
    });
  }

  onAvailBalanceClick() {
    if (this.sourceAccount && !this.disabled) {
      this.$emit('click-avail-balance', this.sourceAccount);
    }
  }
}
</script>

<style scoped lang="less">
.disabled-input-group {
  cursor: not-allowed;
  .input-addon {
    background: #999 !important;
  }
  .total-label {
    cursor: not-allowed;
  }
}
.total-label {
  white-space: nowrap; padding: 0 10px;
}
</style>
